import { navLinks } from "@/root/consts";

export type OrderByValues = "old" | "new";

export type NavLinkType = typeof navLinks[number];

export type UserType = "admin" | "operator";

export enum ExaminationStatus {
  default = "default",
  started= "started",
  finished= "finished",
}
